import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import './style.scss';

const BannerSlider = ({ banners = [], onBonusCase = null, isLogged = false }) => {

    const [current, setCurrent] = useState(0);

    useEffect(() => {
        setCurrent(0);      
    }, [banners]);

    const beforeChange = (currentSlide, nextSlide) => {
        setCurrent(nextSlide);
    }
    
    const settingSlider = {
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 5000,
        beforeChange
    }    

    const handdleClick = (event) => {
        if(!onBonusCase || !banners[current].bonus){
            return;
        }
        onBonusCase(event);
    }

    return (
        <>
        {banners.length > 0
            ?
            <Slider className={`col-12 slick-homepage h-100${isLogged?'':' pb-41'}`} {...settingSlider}>
                {banners.map( (row, keyRow) => {
                    return (
                        <div key={keyRow} className="slide h-100">
                            {row.bonus
                            ?
                            <>
                                <div className="background h-100 d-none d-sm-block"  style={{ backgroundImage: `url(${encodeURI(screen.width>767 ? row.imageName : row.imageMobileName)})` }}>
                                    <a href="#" onClick={ handdleClick } className="button-bonus-step-1"></a>
                                </div>
                                <div className="background h-100 d-sm-none"  style={{ backgroundImage: `url(${encodeURI(screen.width>767 ? row.imageName : row.imageMobileName)})` }}>
                                    <a href="#" onClick={ handdleClick } className="button-bonus-step-1"></a>
                                </div>
                            </>
                            :
                                <div className="background h-100" style={{ backgroundImage: `url(${encodeURI(screen.width>767 ? row.imageName : row.imageMobileName)})` }}></div>
                            }
                        </div>
                    )
                })}
            </Slider>
            :
            <div className="slick-homepage h-100"></div>
        }
        </>
    );
}

BannerSlider.propTypes = {
    banners: PropTypes.array, 
    onBonusCase: PropTypes.func,
    isLogged: PropTypes.bool
};

export default BannerSlider;